<template>
    <button :class="classButton"  :link="link"
    @click="redirectToLink(link)"
    >
    <slot></slot>
    </button>
</template>

<script>
    export default {
        name:"form-button",
        props:{
            classButton:{
                type:String,
                default:''
            },
            link:{
                type:String,
                default: ''
            }

        },
        methods:{
            redirectToLink(link){
                
                link ? window.location.href=link : ''
            }
        }

    }
</script>

<style lang="scss" scoped>

</style>